import StageDeterminerService from '@/services/page/stage-determiner.service'
import firebase from 'firebase/app';
import "firebase/analytics";

export default class Analytics {
  private static _instance?: Analytics;
  private isProd: boolean = false
  private analytics: any

  private constructor() {
    if (Analytics._instance)
      throw new Error("Use Singleton.instance instead of new.");
    Analytics._instance = this;
    this.init()
  }

  private init() {
    this.isProd = !(new StageDeterminerService().isStage())
    if (this.isProd) {
      var firebaseConfig = {
        apiKey: "AIzaSyDdz7sAB8tH5lqkhL67M8ey41B7GjoXlt8",
        authDomain: "randsel-simulation.firebaseapp.com",
        projectId: "randsel-simulation",
        storageBucket: "randsel-simulation.appspot.com",
        messagingSenderId: "451142250304",
        appId: "1:451142250304:web:b92ef7517b36b5f0e5d4a5",
        measurementId: "G-B4ST0DJC4E"
      };
      const app = firebase.initializeApp(firebaseConfig);
      this.analytics = app.analytics()
    }
  }

  static get instance() {
    return Analytics._instance ?? (Analytics._instance = new Analytics());
  }

  // =========================================================

  sendBagsizeEvent(option: any) {
    this.sendOptionEvent('select_bagsize', option);
  }

  sendBodyEvent(option: any) {
    this.sendOptionEvent('select_body', option);
  }

  sendEdgeEvent(option: any) {
    this.sendOptionEvent('select_edge', option);
  }

  sendThreadEvent(option: any) {
    this.sendOptionEvent('select_thread', option);
  }

  sendInsideEvent(option: any) {
    this.sendOptionEvent('select_inside', option);
  }

  sendPocketEvent(option: any) {
    this.sendOptionEvent('select_pocket', option);
  }

  sendSideEvent(option: any) {
    this.sendOptionEvent('select_side', option);
  }

  sendFrontEvent(option: any) {
    this.sendOptionEvent('select_front', option);
  }

  sendTackEvent(option: any) {
    this.sendOptionEvent('select_tack', option);
  }

  sendBackEvent(option: any) {
    this.sendOptionEvent('select_back', option);
  }

  selectStitchDesign(option: any) {
    this.sendOptionEvent('select_stitch_design', option);
  }

  sendNameYesNo(option: any) {
    this.sendOptionEvent('select_NameYesNo', option);
  }

  sendNamecharEvent(option: any) {
    this.sendOptionEvent('select_namechar', option);
  }

  sendNamethreadEvent(option: any) {
    this.sendOptionEvent('select_namethread', option);
  }

  sendConfirmCombinationEvent(combination: any) {
    this.sendOptionEvent('confirm_combination', combination);
  }

  sendResetEvent() {
    this.sendEvent('reset_combination');
  }

  sendSaveFavoriteEvent(number: any) {
    this.sendOptionEvent('save_favorite', number);
  }

  sendLoadFavoriteEvent(number: any) {
    this.sendOptionEvent('load_favorite', number);
  }

  sendShowInstructionEvent() {
    this.sendEvent("show_instruction");
  }

  sendVieworderEvent() {
    this.sendMessageEvent("vieworder_visit", window.location.href);
  }

  sendVieworderMissingParameterEvent() {
    this.sendMessageEvent("error_vieworder_missing_parameter", window.location.href);
  }

  sendTextureLoadErrorEvent(message: string) {
    this.sendMessageEvent("error_texture_load", message);
  }

  sendFontLoadErrorEvent(message: string) {
    this.sendMessageEvent("error_font_load", message);
  }

  sendModelLoadErrorEvent(message: string) {
    this.sendMessageEvent("error_model_load", message);
  }

  sendOrderPdfErrorEvent(message: string) {
    this.sendMessageEvent("error_order_pdf", message);
  }

  sendThreejsNotAvailableErrorEvent(message: string) {
    this.sendMessageEvent("threejs_not_available", message);
  }

  sendCopyLinkEvent() {
    this.sendEvent('copy_link_button_click')
  }

  sendModeChangeEvent(useThree: boolean) {
    this.sendMessageEvent('change_mode', useThree ? '3D' : '2D')
  }


  // =========================================================

  private sendEvent(eventName: string) {
    if (this.isProd) {
      this.analytics.logEvent(eventName);
    }
  }

  private sendOptionEvent(eventName: string, option: any) {
    if (this.isProd) {
      this.analytics.logEvent(eventName, { option: option });
    }
  }

  private sendMessageEvent(eventName: string, message: string) {
    if (this.isProd) {
      this.analytics.logEvent(eventName, { message: message });
    }
  }
}
